module.exports = require("@noble/hashes/sha512");